import {DialogDeleteConfigurationState} from './dialog-delete-configuration.state';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {DialogsState} from '../../+store/dialogs.state';


export class DialogDeleteConfigurationSelectors {

  private static readonly _feature = createFeatureSelector<DialogsState>('dialogs');

  private static readonly _slice = createSelector(
    this._feature,
    (state): DialogDeleteConfigurationState => state.dialogDeleteConfiguration,
  );

  public static readonly isOpen = createSelector(
    this._slice,
    (state) => state.isOpen,
  );

}
